import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { ApiClient } from './client';
import { createApiClient } from './factory';
import { useAuthStore } from '../auth/store';

const ApiContext = createContext<ApiClient | null>(null);

/** Fournit l'ApiClient à l'arbre React ; `client` permet d'injecter un client dans les tests. */
export function ApiProvider({ children, client }: { children: ReactNode; client?: ApiClient }) {
  const value = useMemo(
    () =>
      client ??
      createApiClient(
        () => useAuthStore.getState().token,
        () => useAuthStore.getState().clear(),
      ),
    [client],
  );
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const c = useContext(ApiContext);
  if (!c) throw new Error('useApi doit être utilisé sous <ApiProvider>');
  return c;
}
